import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserDefinedLookupList,
  setFormValue,
  timeIntervalsDDL,
} from "../../../../redux/slices/createdatasetpageslice";
import { CollapsableFormRegion } from "../../../../components/collapsableformregion";
import { Grid } from "@progress/kendo-react-grid";
import { Field } from "@progress/kendo-react-form";
import {
  FormCheckbox,
  FormDropDownList,
  FormInput,
  FormTextArea,
} from "../../../../forms/form-components";

import DatasetGrid from "./datasetgrid";
import DatasetSample from "./datasetsample";
import { FormRegion } from "../../../../components/formregion";
import { useEffectOnce } from "../../../../hooks/useeffectonce";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const DatasetFile = (props) => {
  //#region state
  const { formValues } = props;
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.createDatasetPage);
  const showAlertBase = formValues.DatasetShowAlertBase;
  const { t } = useTranslation();

  //#endregion

  //#region hooks

  useEffect(() => {
    let foundIsUtc = false;
    pageState.formValues.DatasetFields?.forEach((field) => {
      if (field.IsUTC) {
        foundIsUtc = true;
        dispatch(
          setFormValue({
            id: "DatasetShowAlertBase",
            value: true,
          })
        );

        dispatch(
          setFormValue({
            id: "DatasetIsAlertBase",
            value: true,
          })
        );
      }
    });

    if (foundIsUtc === false) {
      dispatch(
        setFormValue({
          id: "DatasetShowAlertBase",
          value: false,
        })
      );
      dispatch(
        setFormValue({
          id: "DatasetIsAlertBase",
          value: false,
        })
      );
    }
  }, [pageState.formValues.DatasetFields]);

  //#endregion

  //#region functions
  const handleOnChange = (id, value, regex) => {
    dispatch(
      setFormValue({ id, value, regex: regex ? regex.toString() : null })
    );
  };
  //#endregion

  let showSampleData = false;
  if (
    pageState.formValues.CreateFrom == "fromfile" &&
    pageState.formValues.IsCheckedImportData == true
  )
    showSampleData = true;

  if (
    pageState.formValues.CreateFrom == "fromdb" &&
    pageState.formValues.DatasetImportData == true
  )
    showSampleData = true;

  return (
    <FormRegion>
      <CollapsableFormRegion
        className="form-region-main"
        title={t("datasets.create.general")}
        open={pageState.formValues.GeneralOpen}
        onToggle={(e) =>
          dispatch(
            setFormValue({
              id: "GeneralOpen",
              value: !pageState.formValues.GeneralOpen,
            })
          )
        }
      >
        <div className="form-group form-group-1">
          <Field
            id={"DatasetName"}
            name={"DatasetName"}
            label={t("datasets.create.name")}
            component={FormInput}
            maxLength={50}
            onChange={(e) =>
              handleOnChange("DatasetName", e.target.value, /[^a-zA-Z0-9_]/g)
            }
            text="Dataset name can include a-zA-Z0-9 and underscore; it’s required, unique and can contain up to 50 characters."
          />
          <Field
            id={"DatasetTitle"}
            name={"DatasetTitle"}
            label={t("datasets.create.title")}
            component={FormInput}
            maxLength={100}
            onChange={(e) =>
              handleOnChange("DatasetTitle", e.target.value, /[^a-zA-Z0-9_ ]/g)
            }
            text="Dataset title can include a-zA-Z0-9 underscore and space; .it’s required, unique and can contain up to 100 characters."
          />
          <Field
            id={"DatasetDescription"}
            name={"DatasetDescription"}
            label={t("datasets.create.description")}
            component={FormTextArea}
            maxLength={255}
            onChange={(e) =>
              handleOnChange("DatasetDescription", e.target.value, null)
            }
          />
          <div className="checkbox-list">
            {/* {showAlertBase && (
              <Field
                id="DatasetIsAlertBase"
                name="DatasetIsAlertBase"
                label={"Is Alert Base"}
                disabled
                title={"If selected, alerts can be set for this dataset."}
                checked={pageState.formValues.DatasetIsAlertBase}
                component={FormCheckbox}
                // onChange={(e) => {
                //   console.log(e);
                //   handleOnChange("DatasetIsAlertBase", e.target.value, null);
                // }}
              />
            )} */}

            {pageState.formValues.CreateFrom == "fromdb" && (
              <Field
                id="DatasetImportData"
                name="DatasetImportData"
                label={t("datasets.create.import")}
                checked={pageState.formValues.DatasetImportData}
                component={FormCheckbox}
                onChange={(e) => {
                  console.log(e);
                  handleOnChange("DatasetImportData", e.target.value, null);
                }}
                className={"mb30"}
              />
            )}

            {pageState.formValues.DatasetImportData &&
              pageState.formValues.CreateFrom == "fromdb" && (
                <Field
                  id="DatasetIsReccurent"
                  name="DatasetIsReccurent"
                  label={t("datasets.create.reccurent")}
                  checked={pageState.formValues.DatasetIsReccurent}
                  component={FormCheckbox}
                  onChange={(e) => {
                    console.log(e);
                    handleOnChange("DatasetIsReccurent", e.target.value, null);
                  }}
                  className={"mb30"}
                />
              )}
          </div>
          {pageState.formValues.DatasetImportData &&
            pageState.formValues.DatasetIsReccurent &&
            pageState.formValues.CreateFrom == "fromdb" && (
              <Field
                id={"DatasetReccursEvery"}
                name={"DatasetReccursEvery"}
                label={t("datasets.create.recurs")}
                component={FormDropDownList}
                data={timeIntervalsDDL}
                dataItemKey="Id"
                textField="Title"
                onChange={(e) => handleOnChange("DatasetReccursEvery", e.value)}
              />
            )}
        </div>
      </CollapsableFormRegion>

      <CollapsableFormRegion
        title={t("datasets.create.fields")}
        className="form-region-main"
        open={pageState.formValues.FieldsOpen}
        onToggle={(e) =>
          dispatch(
            setFormValue({
              id: "FieldsOpen",
              value: !pageState.formValues.FieldsOpen,
            })
          )
        }
      >
        <DatasetGrid
          id="DatasetFields"
          name="DatasetFields"
          formValues={formValues}
        />
      </CollapsableFormRegion>

      {showSampleData && (
        <CollapsableFormRegion
          className="form-region-main"
          title={t("datasets.create.datasample")}
          open={pageState.formValues.DataSampleOpen}
          onToggle={(e) =>
            dispatch(
              setFormValue({
                id: "DataSampleOpen",
                value: !pageState.formValues.DataSampleOpen,
              })
            )
          }
        >
          <DatasetSample />
        </CollapsableFormRegion>
      )}
      <style>
        {`
          .datasets-page .form-region-container{
          margin-bottom:30px;
          }
          .datasets-page .form-region-container .form-region-root .header{
          margin-bottom:10px;
          }

          .datasets-page .form-region-container .dataset-grid{
          width : 100%;
          overflow-x:auto;
          }

          .datasets-page > .content .form-root  .k-form  .checkbox-list .k-form-field:nth-child(1){
                margin-top:32px;
          }

          .datasets-page .checkbox-list{
            display:flex;
            justify-content:space-between;
          }
          `}
      </style>
    </FormRegion>
  );
};

export default DatasetFile;

//#region functions
// const createDatasetFromFile = async () => {
//   let boolRes = false;
//   dispatch(setLoading(true));
//   try {
//     const postbody = JSON.stringify({
//       FileId: fileId,
//       Name: datasetName,
//       Title: datasetTitle,
//       Description: datasetDescription,
//       IsAlertBase: datasetIsAlertBase,
//       SheetName: selectedSheet,
//       ImportData: isCheckedImportData,
//       IsDataReal: isDataReal,
//       StartingRow: startingRow,
//       EndingRow: endingRow,
//       Fields: datasetFields,
//     });
//     const res = await dispatch(
//       CreateDatasetFromFile(token, tenantId, postbody)
//     );

//     if (res.Succeeded === true) {
//       dispatch(setStepName("result"));
//       dispatch(setApiUrl(res.Data.ApiUrl));
//       dispatch(setDatasetId(res.Data.DataSetId));
//       dispatch(setInsertedRows(res.Data.InsertedRows));
//       dispatch(setMessage("Your dataset has been successfully updated"));

//       boolRes = true;
//     } else {
//       dispatch(setReturnMessage(res.Errors[0]?.Message));
//     }
//   } catch (error) {
//     console.error("create dataset from File failed:", error);
//   } finally {
//     dispatch(setLoading(false));
//     return boolRes;
//   }
// };

// const createDatasetFromDBConnection = async () => {
//   let boolRes = false;
//   dispatch(setLoading(true));
//   try {
//     const postbody = JSON.stringify({
//       Name: datasetName,
//       Title: datasetTitle,
//       Description: datasetDescription,
//       IsAlertBase: datasetIsAlertBase,
//       Fields: datasetFields,
//       TableName: selectedTableId,
//       ConnectionId:
//         selectedCnx.ConnectionId === "" ? null : selectedCnx.ConnectionId,
//       DataBaseConnection: {
//         DataBaseTypeId: selectedCnx.DataBaseTypeId,
//         Server: selectedCnx.Server,
//         DataBase: selectedCnx.DataBase,
//         Username: selectedCnx.Username,
//         Password: selectedCnx.Password,
//       },
//     });
//     const res = await dispatch(
//       CreateDataSetFromDbConnection(token, tenantId, postbody)
//     );

//     if (res.Succeeded === true) {
//       dispatch(setStepName("result"));
//       dispatch(setApiUrl(res.Data.ApiUrl));
//       dispatch(setDatasetId(res.Data.DataSetId));
//       dispatch(setInsertedRows(res.Data.InsertedRows));
//       dispatch(
//         setMessage(
//           "Your dataset has been successfully updated , " +
//             res.Data.InsertedRows +
//             " inserted Rows. DatasetId: " +
//             res.Data.DataSetId
//         )
//       );
//       boolRes = true;
//     } else {
//       dispatch(setReturnMessage(res.Errors[0]?.Message));
//     }
//   } catch (error) {
//     console.error("create dataset from File failed:", error);
//   } finally {
//     dispatch(setLoading(false));
//     return boolRes;
//   }
// };
//#endregion
